import {httpGet,httpPut,httpDelete,httpPost} from '../../../../util/request.js';
import appConfig from '../../../../config';

export default class CouponActivityApi{

    static QUERY_COUPON_ACTIVITY_API_URL = appConfig.gatewayUrl+appConfig.smMarketManageServicePath+"/coupon/activity/printCouponActivitys";
    static QUERY_STAMP_ACTIVITY_API_URL = appConfig.gatewayUrl+appConfig.smMarketManageServicePath+"/coupon/activity/stampCouponActivitys";
	

    static queryCouponActivity(params){
		return httpGet(CouponActivityApi.QUERY_COUPON_ACTIVITY_API_URL,params);
    }

    static queryStampActivity(params){
        return httpGet(CouponActivityApi.QUERY_STAMP_ACTIVITY_API_URL,params);
    }
    
}